import React from "react";
import locale from "../../locale";

class LayoutTextBlock extends React.Component
{
	render()
	{
		const {settings} = this.props;
		const title = locale.getProperty(settings, 'title');

		return (
			<aside className="section-text-block" style={settings.style}>
				{title
					? <h1 style={settings.styleHeader}>{title}</h1>
					: null
				}
				<div className="landing-nav-section-text">
					<div dangerouslySetInnerHTML={{__html: settings.text}}></div>
				</div>
			</aside>
		);
	}
}

export default LayoutTextBlock;
